import { useEffect } from "react";
import { TrainingProgramsLayout } from "./style";
import { Outlet } from "react-router-dom";
import { useAppDispatch } from "../../../../../../store/config";
import { resetTrainingPrograms } from "../../../../../../store/features/training-programs/training-programs-slice";

export const TrainingPrograms = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetTrainingPrograms());
    };
  }, []);

  return (
    <TrainingProgramsLayout>
      <Outlet />
    </TrainingProgramsLayout>
  );
};
